// Polyfills for missing global.js / bodyScrollLock.min.js dependencies
if (typeof bodyScroll === 'undefined') {
  var bodyScroll = {
    lock: function(el) { document.body.style.overflow = 'hidden'; },
    unlock: function(el) { document.body.style.overflow = ''; }
  };
}
if (typeof removeTrapFocus === 'undefined') {
  var removeTrapFocus = function(el) { if (el) { try { el.focus(); } catch(e) {} } };
}
if (typeof debounce === 'undefined') {
  var debounce = function(fn, delay) {
    var t; return function() { var args = arguments; clearTimeout(t); t = setTimeout(function(){ fn.apply(this, args); }, delay); };
  };
}
if (typeof updateFreeShipping === 'undefined') {
  var updateFreeShipping = function() {};
}
if (typeof fetchConfig === 'undefined') {
  var fetchConfig = function() { return { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }; };
}

const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
    this.parentElement.addEventListener(
      'shopify:section:select',
      () => this.open()
    );
    this.parentElement.addEventListener(
      'shopify:section:deselect',
      () => this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    cartLink?.setAttribute('role', 'button');
    cartLink?.setAttribute('aria-haspopup', 'dialog');
    cartLink?.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink?.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.querySelector('.cart-drawer__inner').setAttribute('aria-hidden', 'false');

    this.addEventListener('transitionend', () => {
      this.focusOnCartDrawer();
    }, { once: true });

    bodyScroll.lock(this.querySelector('[role="dialog"]'));

    if (document.querySelector('product-bar')) {
      document.querySelector('product-bar').style.opacity = '0';
    }
  }

  close() {
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);

    const headerEl = document.querySelector('header, .header, #shopify-section-header');
    const isHeaderMenuOpen = headerEl ? headerEl.classList.contains('menu-open') : false;

    if (isHeaderMenuOpen) {
      return;
    }

    bodyScroll.unlock(this.querySelector('[role="dialog"]'));

    // if we are on the cart page, resubmit form
    if (window.location.pathname === '/cart') {
      const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }

    if (document.querySelector('product-bar')) {
      document.querySelector('product-bar').removeAttribute('style');
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      if (sectionElement && response.sections && response.sections[section.section]) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          response.sections[section.section],
          section.selector
        );
      }
    });
    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  focusOnCartDrawer() {
    const cartDrawer = this.querySelector('.cart-drawer');
    if (cartDrawer) {
      cartDrawer.focus();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
